// import nlp from 'compromise';
// // import { sentenceCase } from 'text-sentence-case';
// import { titleCase } from 'title-case';
// import englishWords from 'an-array-of-english-words';
// const ENGLISH_WORD_SET = new Set(englishWords);
// // import winkNLP from 'wink-nlp';
// // import model from 'wink-eng-lite-web-model';
// // import x from 'people-names';
// // const wink = winkNLP(model);
// // const its = wink.its;

// export function tokenizeLatex(str) {
//     const tokens = [];
//     let i = 0;
//     let plainBuf = '';

//     function flushPlain() {
//         if (plainBuf.length > 0) {
//             tokens.push({ type: 'text', value: plainBuf });
//             plainBuf = '';
//         }
//     }

//     function consumeBalanced(openChar, closeChar) {
//         let tok = openChar;
//         let depth = 1;
//         i++; // skip the opening char
//         while (i < str.length && depth > 0) {
//             if (str[i] === openChar) depth++;
//             if (str[i] === closeChar) { depth--; if (depth === 0) { tok += closeChar; i++; break; } }
//             tok += str[i];
//             i++;
//         }
//         return tok;
//     }

//     while (i < str.length) {

//         // ── Display math: $$...$$ (must check before single $) ───────────────
//         if (str[i] === '$' && str[i + 1] === '$') {
//             flushPlain();
//             let tok = '$$';
//             i += 2;
//             while (i < str.length && !(str[i] === '$' && str[i + 1] === '$')) {
//                 tok += str[i]; i++;
//             }
//             tok += '$$'; i += 2;
//             tokens.push({ type: 'math', value: tok });
//             continue;
//         }

//         // ── Inline math: $...$ ────────────────────────────────────────────────
//         if (str[i] === '$') {
//             flushPlain();
//             let tok = '$';
//             i++;
//             while (i < str.length && str[i] !== '$') {
//                 if (str[i] === '\\') { tok += str[i]; i++; } // skip escaped chars
//                 tok += str[i]; i++;
//             }
//             tok += '$'; i++;
//             tokens.push({ type: 'math', value: tok });
//             continue;
//         }



//         // ── LaTeX command: \cmdname [opt]{arg}{arg}... ────────────────────────
//         if (str[i] === '\\' && i + 1 < str.length && /[a-zA-Z*@]/.test(str[i + 1])) {
//             flushPlain();
//             let tok = '\\';
//             i++;

//             // Consume command name
//             while (i < str.length && /[a-zA-Z*@]/.test(str[i])) {
//                 tok += str[i]; i++;
//             }

//             // \( ... \)  inline math environment
//             if (tok === '\\(') {
//                 while (i < str.length) {
//                     if (str[i] === '\\' && str.slice(i, i + 2) === '\\)') { tok += '\\)'; i += 2; break; }
//                     tok += str[i]; i++;
//                 }
//                 tokens.push({ type: 'math', value: tok }); continue;
//             }

//             // \[ ... \]  display math environment
//             if (tok === '\\[') {
//                 while (i < str.length) {
//                     if (str[i] === '\\' && str.slice(i, i + 2) === '\\]') { tok += '\\]'; i += 2; break; }
//                     tok += str[i]; i++;
//                 }
//                 tokens.push({ type: 'math', value: tok }); continue;
//             }

//             // Greedily consume all immediately-following argument groups.
//             // Spaces between the command name and its first argument are included.
//             while (i < str.length) {
//                 // Peek for optional whitespace then an argument delimiter
//                 let ws = '';
//                 while (i < str.length && (str[i] === ' ' || str[i] === '\t')) {
//                     ws += str[i]; i++;
//                 }
//                 if (str[i] === '{') {
//                     tok += ws + consumeBalanced('{', '}');
//                 } else if (str[i] === '[') {
//                     tok += ws + consumeBalanced('[', ']');
//                 } else {
//                     // No argument follows — backtrack any whitespace we peeked at
//                     if (ws.length > 0) i -= ws.length;
//                     break;
//                 }
//             }

//             tokens.push({ type: 'command', value: tok });
//             continue;
//         }

//         // ── Plain text character ───────────────────────────────────────────────
//         plainBuf += str[i];
//         i++;
//     }

//     flushPlain();
//     return tokens;
// }


// function isAbbreviation(word) {
//     const letters = word.match(/[a-zA-Z]/g);
//     if (!letters || letters.length < 2) return false;
//     return letters.every(ch => ch === ch.toUpperCase());
// }


// export function applyCustomCase(str, transformFn) {
//     str = str.trim();
//     if (!str) return str;

//     const tokens = tokenizeLatex(str);
//     let firstTextSeen = false;
//     let resetNext = false;

//     return tokens.map((tok, i) => {
//         if (tok.type !== 'text') return tok.value;

//         const isFirst = !firstTextSeen;
//         if (/[a-zA-Z]/.test(tok.value)) firstTextSeen = true;

//         const segments = tok.value.split(/(\b[a-zA-Z]+\b)/);
//         let isFirstSegment = isFirst;

//         return segments.map((seg, idx) => {
//             const isWordSegment = idx % 2 === 1;

//             if (isWordSegment) {
//                 if (isAbbreviation(seg)) {
//                     isFirstSegment = false;
//                     return seg;
//                 }


//                 const shouldBeFirst = isFirstSegment || resetNext;
//                 const result = transformFn(seg, shouldBeFirst);

//                 resetNext = false;
//                 isFirstSegment = false;
//                 return result;
//             }

//             if (/[.!?:]/.test(seg)) {
//                 resetNext = true;
//             }
//             if (/[,]/.test(seg)) {
//                 resetNext = true;
//             }
//             return transformFn(seg, false);
//         }).join('');
//     }).join('');
// }



// export function applyFirstLetterOnlyCase(str, transformFn) {
//     str = str.trim();
//     if (!str) return str;

//     const tokens = tokenizeLatex(str);
//     let firstTextSeen = false;
//     let resetNext = false;

//     return tokens.map((tok, i) => {
//         if (tok.type !== 'text') return tok.value;

//         const isFirst = !firstTextSeen;
//         if (/[a-zA-Z]/.test(tok.value)) firstTextSeen = true;

//         const segments = tok.value.split(/(\b[a-zA-Z]+\b)/);
//         let isFirstSegment = isFirst;

//         return segments.map((seg, idx) => {
//             const isWordSegment = idx % 2 === 1;

//             if (isWordSegment) {
//                 if (isAbbreviation(seg)) {
//                     isFirstSegment = false;
//                     return seg;
//                 }


//                 const shouldBeFirst = isFirstSegment || resetNext;
//                 const result = transformFn(seg, shouldBeFirst);

//                 resetNext = false;
//                 isFirstSegment = false;
//                 console.log("the value come from the transformFn with caps or usuall", result);
//                 return result;
//             }

//             // if (/[.!?:]/.test(seg)) {
//             if (/[.!?:]/.test(seg)) {
//                 resetNext = true;
//             }

//             return transformFn(seg, false);
//         }).join('');
//     }).join('');
// }






// export function changeToSentenceCase(content) {
//     if (!content || !content.trim()) return content;

//     return applyCustomCase(content, (text, isFirst) => {
//         // Only process segments that contain letters
//         if (/[a-zA-Z]/.test(text)) {
//             let doc = nlp(text);
//             if (isFirst) {
//                 // if (doc.has('#Preposition')) {
//                 //     return text.toLowerCase();
//                 // }
//                 return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
//             }
//             console.log("the word is in nlp ", text, "the noun is ", doc.has('#Noun'))
//             if (doc.has('#ProperNoun') || doc.has('#Acronym') || doc.has('#TitleCase') || doc.has('#Noun')) {
//                 return text; // Keep it exactly as it is (e.g., "Ajith")
//                 // return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
//             }
//             console.log("the word is in nlp ", text, "the preposition is ", doc.has('#Preposition'))
//             if (doc.has('#Preposition')) {
//                 return text.toLowerCase();
//             }

//             // 3. Otherwise, make it lowercase
//             return text.toLowerCase();
//         }

//         return text;
//     });
// }




// const TITLE_SKIP_WORDS = new Set([
//     'a', 'an', 'the',
//     'and', 'but', 'or', 'nor', 'for', 'so', 'yet',
//     'at', 'by', 'in', 'of', 'on', 'to', 'up', 'as', 'if',
//     'into', 'onto', 'via', 'per', 'than', 'from', 'with',
//     'over', 'past', 'down', 'near', 'like',
// ]);

// // export function changeToTitleCase(content) {
// //     if (!content || !content.trim()) return content;

// //     let isFirstWord = true;

// //     return applyCustomCase(content, (text) => {
// //         return text.replace(/([a-zA-Z]+)/g, (word) => {
// //             const lower = word.toLowerCase();
// //             const shouldCap = isFirstWord || !TITLE_SKIP_WORDS.has(lower);
// //             isFirstWord = false;
// //             return shouldCap
// //                 ? lower[0].toUpperCase() + lower.slice(1)
// //                 : lower;
// //         }).replace(/[^a-zA-Z]+/g, match => {
// //             if (/[.!?]/.test(match)) isFirstWord = true;
// //             return match;
// //         });
// //     });
// // }


// // export function changeToTitleCase(content) {
// //     if (!content || !content.trim()) return content;

// //     return titleCase(content);
// // }

// export function changeToKeywordCase(content) {
//     if (!content || !content.trim()) return content;
//     const doc = nlp(content);
//     const detectedNames = new Set();

//     doc.people().forEach(person => {
//         person.out('text').split(/\s+/).forEach(word => {
//             const clean = word.replace(/[^a-zA-Z]/g, '').toLowerCase();
//             if (clean.length > 0) detectedNames.add(clean);
//         });
//     });
//     console.log("detected names are ", detectedNames);
//     let output = applyFirstLetterOnlyCase(content, (text, isFirst) => {
//         if (!/[a-zA-Z]/.test(text)) return text;
//         if (isFirst) {
//             return text.charAt(0).toUpperCase() + text.slice(1);
//         }
//         const cleanText = text.replace(/[^a-zA-Z]/g, '').toLowerCase();
//         if (detectedNames.has(cleanText)) {
//             return text.charAt(0).toUpperCase() + text.slice(1);
//         }
//         // console.log("the word is :", cleanText, "is propernoun or not:", doc.has("#ProperNoun"))
//         // if (doc.has("#ProperNoun")) {
//         //     return text.charAt(0).toUpperCase() + text.slice(1)
//         // }
//         return text;
//     });
//     console.log("the output is ", output)
//     return output;
// }

// // export function changeToKeywordCase(content) {
// //     if (!content || !content.trim()) return content;
// //     const doc = nlp(content);
// //     const detectedNames = new Set();
// //     const result = sentenceCase(content);
// //     return result;

// // }




// export function changeToLowerCase(content) {
//     return applyCustomCase(content, (text) => text.toLowerCase());
// }


// export function changeToUpperCase(content) {
//     return applyCustomCase(content, (text) => text.toUpperCase());
// }






// export function changeToTitleCase(content) {
//     let tokens = [];
//     let textdata = "";
//     let order = 0;

//     function flush() {
//         if (textdata.length > 0) {
//             order++;
//             tokens.push({
//                 type: "text",
//                 data: textdata,
//                 orderposition: order
//             });
//             textdata = "";
//         }
//     }

//     function extractMath(content, i, openDelim, closeDelim) {
//         let mathContent = openDelim;
//         i += openDelim.length;
//         while (i < content.length) {
//             if (content.startsWith(closeDelim, i)) {
//                 mathContent += closeDelim;
//                 i += closeDelim.length;
//                 break;
//             }
//             mathContent += content[i];
//             i++;
//         }
//         return { mathContent, newIndex: i };
//     }

//     for (let i = 0; i < content.length; i++) {
//         if (content.startsWith("$$", i)) {
//             flush();
//             const { mathContent, newIndex } = extractMath(content, i, "$$", "$$");
//             order++;
//             tokens.push({ type: "math", data: mathContent, orderposition: order });
//             i = newIndex - 1;

//         } else if (content[i] === "$") {
//             flush();
//             const { mathContent, newIndex } = extractMath(content, i, "$", "$");
//             order++;
//             tokens.push({ type: "math", data: mathContent, orderposition: order });
//             i = newIndex - 1;

//         } else if (content.startsWith("\\(", i)) {
//             flush();
//             const { mathContent, newIndex } = extractMath(content, i, "\\(", "\\)");
//             order++;
//             tokens.push({ type: "math", data: mathContent, orderposition: order });
//             i = newIndex - 1;

//         } else if (content.startsWith("\\[", i)) {
//             flush();
//             const { mathContent, newIndex } = extractMath(content, i, "\\[", "\\]");
//             order++;
//             tokens.push({ type: "math", data: mathContent, orderposition: order });
//             i = newIndex - 1;

//         } else {
//             textdata += content[i];
//         }
//     }

//     flush();

//     // Sentence case: only capitalize first letter of the entire content


//     const cased = tokens.map(token => {
//         if (token.type === "text") {
//             return { ...token, data: toTitleCase(token.data) };
//         }
//         return token; // math is never touched
//     });

//     const result = cased
//         .sort((a, b) => a.orderposition - b.orderposition)
//         .map(t => t.data)
//         .join("");

//     console.log("Final tokens:", cased);
//     return result;
// }

// // function toSentenceCase(str) {
// //     console.log("the data coming to the tosentececase is :", str);
// //     // Capitalize only the first actual letter, skip leading spaces/symbols
// //     return str.replace(/^\s*([a-z])/, char => char.toUpperCase());
// // }


// // function toSentenceCase(str) {
// //     return sentenceCase(str);
// // }

// const librarytoConvert = ['brusselator']


// export function HeadingSentenceCase(content) {
//     if (!content || !content.trim()) return content;

//     const doc = nlp(content);
//     const detectedNames = new Set();

//     // Full-content pass: catches "Issac Newton" together
//     doc.people().forEach(person => {
//         person.out('text').split(/\s+/).forEach(word => {
//             const clean = word.replace(/[^a-zA-Z]/g, '').toLowerCase();
//             if (clean.length > 0) detectedNames.add(clean);
//         });
//     });

//     // Also extract #LastName tags separately from full content
//     // This catches surnames even without a first name beside them
//     doc.match('#LastName').forEach(match => {
//         const clean = match.out('text').replace(/[^a-zA-Z]/g, '').toLowerCase();
//         if (clean.length > 0) detectedNames.add(clean);
//     });

//     // Also extract #FirstName tags separately
//     doc.match('#FirstName').forEach(match => {
//         const clean = match.out('text').replace(/[^a-zA-Z]/g, '').toLowerCase();
//         if (clean.length > 0) detectedNames.add(clean);
//     });

//     let output = applyFirstLetterOnlyCase(content, (text, isFirst) => {
//         console.log("the words are in the section and subsection sentence case is :", text);
//         if (!/[a-zA-Z]/.test(text)) return text;

//         if (isFirst) {
//             return text.charAt(0).toUpperCase() + text.slice(1);
//         }

//         if (librarytoConvert.includes(text)) {
//             return text.charAt(0).toUpperCase() + text.slice(1);
//         }
//         const cleanText = text.replace(/[^a-zA-Z]/g, '').toLowerCase();

//         if (detectedNames.has(cleanText)) {
//             return text.charAt(0).toUpperCase() + text.slice(1);
//         }

//         // Per-word check: also tag #LastName and #FirstName individually
//         const docs = nlp(text);
//         console.log("the word Brusselator is coming:", text, docs.has('#ProperNoun'));
//         if (
//             docs.has('#ProperNoun') ||
//             docs.has('#LastName') ||     // ← catches "Newton" alone
//             docs.has('#FirstName')
//             // doc.has('#Person')
//         ) {
//             return text.charAt(0).toUpperCase() + text.slice(1);
//         }

//         // if (
//         //     !ENGLISH_WORD_SET.has(cleanText) &&
//         //     /^[a-z][a-z'-]+$/.test(cleanText) &&
//         //     cleanText.length > 2 &&
//         //     !/[^aeiou]{4,}/.test(cleanText) &&         // No 4+ consonant clusters (dummy check)
//         //     (cleanText.match(/[aeiou]/g) || []).length >= 2
//         // ) {
//         //     return text.charAt(0).toUpperCase() + text.slice(1);
//         // }

//         return text.toLowerCase();
//     });

//     console.log("the output of this headingSentenceCase is :", output);
//     return output;
// }



// function toTitleCase(str) {
//     return titleCase(str);
// }





import nlp from 'compromise';
import { titleCase } from 'title-case';
import englishWords from 'an-array-of-english-words';
const ENGLISH_WORD_SET = new Set(englishWords);


const TITLE_SKIP_WORDS = new Set([
    'a', 'an', 'the',
    'and', 'but', 'or', 'nor', 'for', 'so', 'yet',
    'at', 'by', 'in', 'of', 'on', 'to', 'up', 'as', 'if',
    'into', 'onto', 'via', 'per', 'than', 'from', 'with',
    'over', 'past', 'down', 'near', 'like',
]);

const librarytoConvert = ['brusselator'];


export function tokenizeLatex(str) {
    const tokens = [];
    let i = 0;
    let plainBuf = '';

    function flushPlain() {
        if (plainBuf.length > 0) {
            tokens.push({ type: 'text', value: plainBuf });
            plainBuf = '';
        }
    }

    function consumeBalanced(openChar, closeChar) {
        let tok = openChar;
        let depth = 1;
        i++;
        while (i < str.length && depth > 0) {
            if (str[i] === openChar) depth++;
            if (str[i] === closeChar) { depth--; if (depth === 0) { tok += closeChar; i++; break; } }
            tok += str[i];
            i++;
        }
        return tok;
    }

    while (i < str.length) {
        // Display math: $$...$$
        if (str[i] === '$' && str[i + 1] === '$') {
            flushPlain();
            let tok = '$$'; i += 2;
            while (i < str.length && !(str[i] === '$' && str[i + 1] === '$')) { tok += str[i]; i++; }
            tok += '$$'; i += 2;
            tokens.push({ type: 'math', value: tok });
            continue;
        }

        // Inline math: $...$
        if (str[i] === '$') {
            flushPlain();
            let tok = '$'; i++;
            while (i < str.length && str[i] !== '$') {
                if (str[i] === '\\') { tok += str[i]; i++; }
                tok += str[i]; i++;
            }
            tok += '$'; i++;
            tokens.push({ type: 'math', value: tok });
            continue;
        }

        // LaTeX command: \cmdname [opt]{arg}...
        if (str[i] === '\\' && i + 1 < str.length && /[a-zA-Z*@]/.test(str[i + 1])) {
            flushPlain();
            let tok = '\\'; i++;
            while (i < str.length && /[a-zA-Z*@]/.test(str[i])) { tok += str[i]; i++; }

            if (tok === '\\(') {
                while (i < str.length) {
                    if (str[i] === '\\' && str.slice(i, i + 2) === '\\)') { tok += '\\)'; i += 2; break; }
                    tok += str[i]; i++;
                }
                tokens.push({ type: 'math', value: tok }); continue;
            }
            if (tok === '\\[') {
                while (i < str.length) {
                    if (str[i] === '\\' && str.slice(i, i + 2) === '\\]') { tok += '\\]'; i += 2; break; }
                    tok += str[i]; i++;
                }
                tokens.push({ type: 'math', value: tok }); continue;
            }

            while (i < str.length) {
                let ws = '';
                while (i < str.length && (str[i] === ' ' || str[i] === '\t')) { ws += str[i]; i++; }
                if (str[i] === '{') tok += ws + consumeBalanced('{', '}');
                else if (str[i] === '[') tok += ws + consumeBalanced('[', ']');
                else { if (ws.length > 0) i -= ws.length; break; }
            }
            tokens.push({ type: 'command', value: tok });
            continue;
        }

        plainBuf += str[i];
        i++;
    }

    flushPlain();
    return tokens;
}


function isAbbreviation(word) {
    const letters = word.match(/[a-zA-Z]/g);
    if (!letters || letters.length < 2) return false;
    return letters.every(ch => ch === ch.toUpperCase());
}



export function applyCustomCase(str, transformFn) {
    str = str.trim();
    if (!str) return str;

    const tokens = tokenizeLatex(str);
    let firstTextSeen = false;
    let resetNext = false;

    return tokens.map((tok) => {
        if (tok.type !== 'text') return tok.value;

        const isFirst = !firstTextSeen;
        if (/[a-zA-Z]/.test(tok.value)) firstTextSeen = true;

        const segments = tok.value.split(/(\b[a-zA-Z]+\b)/);
        let isFirstSegment = isFirst;

        return segments.map((seg, idx) => {
            const isWordSegment = idx % 2 === 1;

            if (isWordSegment) {
                if (isAbbreviation(seg)) { isFirstSegment = false; return seg; }
                const shouldBeFirst = isFirstSegment || resetNext;
                const result = transformFn(seg, shouldBeFirst);
                resetNext = false;
                isFirstSegment = false;
                return result;
            }

            if (/[.!?:]/.test(seg)) resetNext = true;
            if (/[,]/.test(seg)) resetNext = true;
            return transformFn(seg, false);
        }).join('');
    }).join('');
}



export function applyFirstLetterOnlyCase(str, transformFn) {
    str = str.trim();
    if (!str) return str;

    const tokens = tokenizeLatex(str);
    let firstTextSeen = false;
    let resetNext = false;

    return tokens.map((tok) => {
        if (tok.type !== 'text') return tok.value;

        const isFirst = !firstTextSeen;
        if (/[a-zA-Z]/.test(tok.value)) firstTextSeen = true;

        const segments = tok.value.split(/(\b[a-zA-Z]+\b)/);
        let isFirstSegment = isFirst;

        return segments.map((seg, idx) => {
            const isWordSegment = idx % 2 === 1;

            if (isWordSegment) {
                if (isAbbreviation(seg)) { isFirstSegment = false; return seg; }
                const shouldBeFirst = isFirstSegment || resetNext;
                const result = transformFn(seg, shouldBeFirst);
                resetNext = false;
                isFirstSegment = false;
                return result;
            }

            if (/[.!?:]/.test(seg)) resetNext = true;
            return transformFn(seg, false);
        }).join('');
    }).join('');
}



export function changeToSentenceCase(content) {
    if (!content || !content.trim()) return content;

    return applyCustomCase(content, (text, isFirst) => {
        if (/[a-zA-Z]/.test(text)) {
            let doc = nlp(text);
            if (isFirst) {
                return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
            }
            if (doc.has('#ProperNoun') || doc.has('#Acronym') || doc.has('#TitleCase') || doc.has('#Noun')) {
                return text;
            }
            if (doc.has('#Preposition')) {
                return text.toLowerCase();
            }
            return text.toLowerCase();
        }
        return text;
    });
}



export function changeToTitleCase(content) {
    if (!content || !content.trim()) return content;

    const tokens = tokenizeLatex(content);


    const textTokenIndices = tokens
        .map((t, i) => (t.type === 'text' ? i : -1))
        .filter(i => i !== -1);

    if (textTokenIndices.length === 0) return content;

    const firstTextIdx = textTokenIndices[0];
    const lastTextIdx = textTokenIndices[textTokenIndices.length - 1];

    return tokens.map((token, tokenIdx) => {


        if (token.type !== 'text') return token.value;

        const isFirstTextToken = tokenIdx === firstTextIdx;
        const isLastTextToken = tokenIdx === lastTextIdx;


        const parts = token.value.split(/(\s+)/);
        const wordParts = parts.filter(p => /\S/.test(p));
        let wordIdx = 0;

        return parts.map(part => {


            if (/^\s+$/.test(part)) return part;

            const currentWordIdx = wordIdx++;
            const isFirstWord = isFirstTextToken && currentWordIdx === 0;
            const isLastWord = isLastTextToken && currentWordIdx === wordParts.length - 1;
            const lower = part.toLowerCase();


            if (isAbbreviation(part)) return part;


            if (isFirstWord || isLastWord) {
                return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
            }


            if (TITLE_SKIP_WORDS.has(lower)) return lower;


            return part.charAt(0).toUpperCase() + part.slice(1).toLowerCase();
        }).join('');

    }).join('');
}


export function HeadingSentenceCase(content) {
    if (!content || !content.trim()) return content;

    const tokens_pre = tokenizeLatex(content);
    const allLetters = (tokens_pre
        .filter(t => t.type === 'text')
        .map(t => t.value)
        .join('')
        .match(/[a-zA-Z]/g) || []);
    const upperCount = allLetters.filter(c => c !== c.toLowerCase()).length;
    const isAllCaps = allLetters.length > 3 && (upperCount / allLetters.length) > 0.8;

    if (isAllCaps) {
        content = tokens_pre
            .map(t => {
                if (t.type !== 'text') return t.value;
                return t.value.replace(/\b[a-zA-Z]+\b/g, word => {
                    const lower = word.toLowerCase();


                    if (ENGLISH_WORD_SET.has(lower)) return lower;

                    const wordCheckDoc = nlp(lower);
                    if (
                        wordCheckDoc.has('#ProperNoun') ||
                        wordCheckDoc.has('#Place') ||
                        wordCheckDoc.has('#LastName') ||
                        wordCheckDoc.has('#FirstName')
                    ) {
                        return lower;
                    }


                    const letters2 = word.match(/[a-zA-Z]/g);
                    const isAbbr = letters2 &&
                        letters2.length >= 2 &&
                        letters2.length <= 8 &&
                        letters2.every(ch => ch === ch.toUpperCase());

                    return isAbbr ? word : lower;
                });
            })
            .join('');
    }


    const doc = nlp(content);
    const detectedNames = new Set();

    doc.people().forEach(person => {
        person.out('text').split(/\s+/).forEach(word => {
            const clean = word.replace(/[^a-zA-Z]/g, '').toLowerCase();
            if (clean.length > 0) detectedNames.add(clean);
        });
    });
    doc.match('#LastName').forEach(m => {
        const clean = m.out('text').replace(/[^a-zA-Z]/g, '').toLowerCase();
        if (clean) detectedNames.add(clean);
    });
    doc.match('#FirstName').forEach(m => {
        const clean = m.out('text').replace(/[^a-zA-Z]/g, '').toLowerCase();
        if (clean) detectedNames.add(clean);
    });

    let output = applyFirstLetterOnlyCase(content, (text, isFirst) => {
        if (!/[a-zA-Z]/.test(text)) return text;


        if (isFirst) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }


        if (librarytoConvert.includes(text.toLowerCase())) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }


        if (isAbbreviation(text)) return text;


        const cleanText = text.replace(/[^a-zA-Z]/g, '').toLowerCase();
        if (detectedNames.has(cleanText)) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }


        const wordDoc = nlp(text);
        if (
            wordDoc.has('#ProperNoun') ||
            wordDoc.has('#LastName') ||
            wordDoc.has('#FirstName')
        ) {
            const isPlaceOrPerson =
                wordDoc.has('#Place') ||
                wordDoc.has('#City') ||
                wordDoc.has('#Country') ||
                wordDoc.has('#Person') ||
                wordDoc.has('#LastName') ||
                wordDoc.has('#FirstName');

            if (isPlaceOrPerson) {
                return text.charAt(0).toUpperCase() + text.slice(1);
            }
            // return text.charAt(0).toUpperCase() + text.slice(1);
            const lettersOnly2 = text.match(/[a-zA-Z]/g) || [];
            const isPlainLowerWord2 = /^[a-z]+$/.test(text);
            if (
                isPlainLowerWord2 &&
                lettersOnly2.length >= 2 &&
                lettersOnly2.length <= 6 &&
                !ENGLISH_WORD_SET.has(cleanText)
            ) {
                return text.toUpperCase();
            }
            return text.charAt(0).toUpperCase() + text.slice(1);
        }


        const startsWithCap = text.charAt(0) === text.charAt(0).toUpperCase()
            && text.charAt(0) !== text.charAt(0).toLowerCase();
        const isCommonWord = ENGLISH_WORD_SET.has(cleanText);

        if (startsWithCap && !isCommonWord) {
            return text.charAt(0).toUpperCase() + text.slice(1);
        }

        const lettersOnly = text.match(/[a-zA-Z]/g) || [];
        const isPlainLowerWord = /^[a-z]+$/.test(text);
        if (
            isPlainLowerWord &&
            lettersOnly.length >= 2 &&
            lettersOnly.length <= 6 &&
            !isCommonWord
        ) {
            return text.toUpperCase();
        }


        return text.toLowerCase();
    });

    return output;
}



export function changeToKeywordCase(content) {
    if (!content || !content.trim()) return content;
    const doc = nlp(content);
    const detectedNames = new Set();

    doc.people().forEach(person => {
        person.out('text').split(/\s+/).forEach(word => {
            const clean = word.replace(/[^a-zA-Z]/g, '').toLowerCase();
            if (clean.length > 0) detectedNames.add(clean);
        });
    });

    let output = applyFirstLetterOnlyCase(content, (text, isFirst) => {
        if (!/[a-zA-Z]/.test(text)) return text;
        if (isFirst) return text.charAt(0).toUpperCase() + text.slice(1);

        if (isAbbreviation(text)) return text;

        const cleanText = text.replace(/[^a-zA-Z]/g, '').toLowerCase();
        if (detectedNames.has(cleanText)) return text.charAt(0).toUpperCase() + text.slice(1);


        const wordDoc = nlp(text);
        const isPlainLowerWord = /^[a-z]+$/.test(text);
        const lettersOnly = text.match(/[a-zA-Z]/g) || [];
        const looksLikeAbbr =
            isPlainLowerWord &&
            lettersOnly.length >= 2 &&
            lettersOnly.length <= 6 &&
            !ENGLISH_WORD_SET.has(cleanText);

        if (looksLikeAbbr && (wordDoc.has('#ProperNoun') || wordDoc.has('#LastName') || wordDoc.has('#FirstName'))) {
            return text.toUpperCase();
        }
        if (looksLikeAbbr && !wordDoc.has('#ProperNoun') && !wordDoc.has('#LastName') && !wordDoc.has('#FirstName')) {
            return text.toUpperCase();
        }

        return text.toLowerCase();
    });

    return output;
}

export function changeToLowerCase(content) {
    return applyCustomCase(content, (text) => text.toLowerCase());
}

export function changeToUpperCase(content) {
    return applyCustomCase(content, (text) => text.toUpperCase());
}